<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-toggle-menu-button></app-toggle-menu-button>
    </ion-buttons>

    <ion-title>
      <div class="ion-text-wrap">
        {{ materialTitle$ | async }}
      </div>
    </ion-title>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar
      #searchInput
      (ionInput)="searchFilter$.next($event.target.value)"
      appHelpManual
      [topic]="topic"></ion-searchbar>
    <ion-buttons slot="end">
      <app-filter-selection
        [filterOptions]="filterOptions$ | async"
        [service]="materialItemsService"
        cssClass=""></app-filter-selection>
    </ion-buttons>
    <ion-progress-bar
      *ngIf="(materialList$ | async) === false || (isLoading$ | async)"
      type="indeterminate"></ion-progress-bar>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div
    (onEscape)="onCancelClick()"
    [dataSource$]="materialList$"
    [selectedIndex]="selectedIndex"
    id="table-element"
    appTableRowMovement>
    <app-material-list-table
      #listOrTable
      (onClickEvent)="onClick($event)"
      (doubleClickEvent)="onDoubleClick()"
      (sortEvent)="onSort($event)"
      *ngIf="showTable$ | async"
      [materialList$]="materialList$"
      [selectedIndex$]="selectedIndex"
      [tableColumns$]="tableColumns$"></app-material-list-table>

    <app-material-list-item
      #listOrTable
      (onClickEvent)="onClick($event)"
      *ngIf="(showTable$ | async) === false"
      [materialList$]="materialList$"
      [selectedIndex$]="selectedIndex"
      [tableColumns$]="tableColumns$"></app-material-list-item>
  </div>

  <ion-infinite-scroll
    (ionInfinite)="loadData($event)"
    *ngIf="(lastPage$ | async) === false"
    threshold="100px">
    <ion-infinite-scroll-content
      loadingSpinner="bubbles"
      loadingText="{{
        texts.general.loadMore | translate
      }}"></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-tabs class="admia-toolbar-buttons">
      <ion-tab-bar slot="start">
        <ion-tab-button
          (click)="onNew($event)"
          [disabled]="isReadOnly$ | async"
          tab="tab1">
          <ion-icon name="add"></ion-icon>
          <ion-label>{{ texts.dayInfo.new | translate }}</ion-label>
        </ion-tab-button>

        <ion-tab-button
          (click)="onEdit($event)"
          [disabled]="!!(editable$ | async) === false || (isReadOnly$ | async)"
          tab="tab2">
          <ion-icon name="create"></ion-icon>
          <ion-label>{{ texts.dayInfo.change | translate }}</ion-label>
        </ion-tab-button>

        <ion-tab-button
          (click)="onDelete($event)"
          [disabled]="!!(editable$ | async) === false || (isReadOnly$ | async)"
          tab="tab3">
          <ion-icon name="close"></ion-icon>
          <ion-label>{{ texts.dayInfo.delete | translate }}</ion-label>
        </ion-tab-button>

        <ion-tab-button (click)="onCancelWithEvent($event)">
          <ion-icon name="arrow-back"></ion-icon>
          <ion-label>
            {{ texts.general.back | translate }}
          </ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>

    <ion-buttons slot="end">
      <app-column-selection
        [service]="materialItemsService"
        [tableColumns]="tableColumns$ | async"
        [disabled]="isReadOnly$ | async"
        cssClass=""></app-column-selection>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
